import styled from "styled-components";
import { Variables } from "../../../../../styles/Variables";

export const ContainerMain = styled.div`
  z-index: 1;
  position: relative;
  margin-top: 50px;
  width: 70%;
  height: 200px;
  background-color: ${Variables.colorWhite};
  border-radius: 10px;
  box-shadow: 8px 4px 20px rgba(0, 0, 0, 0.5);
  cursor: pointer;

  @media (max-width: 1440px) {
    width: 80%;
  }

  @media (max-width: ${Variables.maxLaptops}) {
    width: 80%;
  }

  @media (max-width: ${Variables.maxTablet}) {
    width: 100%;
    height: 200px;
  }

  @media (max-width: ${Variables.maxMobile}) {
    width: 100%;
    height: 400px;
  }

  &:hover {
    transform: scale(1.05);
  }
`;

export const ContainerMainCustom = styled.div`
  z-index: 1;
  position: relative;
  margin-top: 50px;
  width: 90%;
  background-color: ${Variables.colorWhite};
  border-radius: 10px;
  box-shadow: 8px 4px 20px rgba(0, 0, 0, 0.5);
  cursor: pointer;
`;

export const ContainerGradient = styled.div`
  z-index: 3;
  position: absolute;
  top: -5%;
  display: flex;
  align-items: center;
  width: 100%;
  height: 100%;
  border-top-right-radius: 10px;
  background: linear-gradient(80deg, rgba(237, 243, 255, 1) 50%, rgba(255, 255, 255, 1) 100%);
`;

export const ContainerGreenBack = styled.div`
  z-index: 2;
  position: absolute;
  right: -2%;
  width: 10%;
  height: 80%;
  border-radius: 20px;
  background-color: #97c25f;

  @media (max-width: ${Variables.maxLaptops}) {
    border-radius: 10px;
  }

  @media (max-width: ${Variables.maxTablet}) {
    border-radius: 10px;
  }
`;

export const ContainerNumber = styled.div`
  position: relative;
  margin-right: 20px;
  width: 11.5%;
  height: 100%;

  @media (max-width: 1440px) {
    width: 19%;
  }

  @media (max-width: ${Variables.maxLaptops}) {
    width: 30%;
  }

  @media (max-width: ${Variables.maxTablet}) {
    width: 34%;
  }

  @media (max-width: ${Variables.maxMobile}) {
    position: absolute;
    top: 10px;
    right: 0;
    width: 60px;
    height: 60px;
  }
`;

export const ContainerCircle = styled.div`
  display: flex;
  width: 100%;
  height: 100%;
  rotate: -57deg;
  border-radius: 100px;
`;

export const FirstColor = styled.div`
  width: 50%;
  height: 100%;
  background-color: #7da047;
  border-bottom-left-radius: 100px;
  border-top-left-radius: 100px;
`;

export const SecondColor = styled.div`
  width: 50%;
  height: 100%;
  background-color: #97c25f;
  border-bottom-right-radius: 100px;
  border-top-right-radius: 100px;
`;

export const TextNumberOption = styled.div`
  position: absolute;
  top: 10%;
  left: 10%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80%;
  height: 80%;
  font-size: 50px;
  font-weight: 700;
  border-radius: 100px;
  background-color: ${Variables.colorWhite};
`;

export const ContainerInfo = styled.div`
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  padding: 10px;
  width: ${({ one }) => (one ? `86%` : `43%`)};
  height: 90%;

  @media (max-width: ${Variables.maxMobile}) {
    margin: 0 auto;
  }
`;

export const ContainerSectionInfo = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: ${Variables.maxTablet}) {
    flex-direction: column;
  }
`;

export const TextNumbers = styled.p`
  font-size: 17px;
  font-weight: 700;
  padding-right: 5px;
  color: rgba(0, 0, 0, 0.5);

  @media (max-width: 1440px) {
    font-size: 14px;
    ${({ blue }) => blue && `width: 80%;`}
  }

  @media (max-width: ${Variables.maxLaptops}) {
    font-size: 14px;
    ${({ blue }) => blue && `width: 80%;`}
  }

  @media (max-width: ${Variables.maxTablet}) {
    font-size: 14px;
    ${({ blue }) => blue && `width: 70%;`}
  }
`;

export const TextOption = styled.p`
  box-sizing: border-box;
  margin-left: 10px;
  width: 48%;
  font-size: 15px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.5);

  @media (max-width: 1440px) {
    font-size: 11px;
    width: 46%;
  }

  @media (max-width: ${Variables.maxLaptops}) {
    font-size: 11px;
    width: 46%;
  }

  @media (max-width: ${Variables.maxTablet}) {
    font-size: 12px;
    width: 90%;
  }
`;
